import * as React from 'react';
import Base, { Props as BaseProps, TypeColors } from '../Base/Base';
import './Dot.css';

export interface Props extends BaseProps {
  /** Color of the dot. Any of the palette colors is acceptable */
  backgroundColor?: TypeColors;
  /** Size of the dot */
  size: string;
}

/** A simple coloured dot.  */
const Dot: React.FunctionComponent<Props> = (props: Props) => {
  const { backgroundColor, size, ...rest } = props;

  return (
    <Base { ...rest }
        backgroundColor={ backgroundColor }
        className="Dot"
        height={ size }
        width={ size } />
  );
};

export default Dot;
